module.exports = __webpack_public_path__ + "static/media/view6_bg2.effbca8e.jpg";